import { render, staticRenderFns } from "./ColorSettingsPage.vue?vue&type=template&id=01c9ec4e&"
import script from "./ColorSettingsPage.vue?vue&type=script&lang=js&"
export * from "./ColorSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports